import React from "react";
import ScreenRecorder from "./ScreenRecorder";
import { AsciiHeader } from "@/components/ui/ascii-theme";

function AssetRecorder() {
  return (
    <div className="min-h-screen bg-white text-black px-2 sm:px-4 py-2 sm:py-4 font-mono text-xs sm:text-sm">
      <div className="w-full max-w-6xl mx-auto">
        {/* ASCII Art Header */}
        <AsciiHeader 
          title="SCREEN RECORDER" 
          subtitle="record • save • share"
        />

        {/* Main Content */}
        <ScreenRecorder />

        {/* Footer with ASCII separator */}
        <div className="mt-8 pt-4 border-t-2 border-black">
          <pre className="text-center text-[0.65rem] sm:text-xs opacity-60">
            {`─────────────────────────────────────────────────────────────────
Built by Max Maio | max@midship.ai | midship.ai
─────────────────────────────────────────────────────────────────`}
          </pre>
        </div>
      </div>
    </div>
  );
}

export default AssetRecorder;
